import { render, staticRenderFns } from "./ModalCompareBalance.vue?vue&type=template&id=07ae191e&scoped=true&"
import script from "./ModalCompareBalance.vue?vue&type=script&lang=js&"
export * from "./ModalCompareBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ae191e",
  null
  
)

export default component.exports